/* eslint-disable import/no-anonymous-default-export */
import {
    UPDATE_LANG    
} from './../constants/appConstants';

export default function (state = {}, action) {
    switch (action.type) {
        case UPDATE_LANG:
            const {langTxt, langUrl} = action.payload;
            return { ...state, url: langUrl, text: langTxt};
        default:
            return state;
    }
}